const map = {
	"./1.jpg": 5644,
	"./2.jpg": 6267,
	"./3.jpg": 8929,
	"./4.jpg": 8645,
	"./5.jpg": 4680,
	"./6.jpg": 1959,
	"./7.jpg": 4442,
	"./8.jpg": 1793,
	"./brand/1.jpg": 5350,
	"./brand/2.jpg": 4929,
	"./brand/3.jpg": 6884,
	"./brand/4.jpg": 1199,
	"./brand/5.jpg": 3266
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1094;